import axios from 'axios';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

const state = {
  plans: [],
  lastFetched: 0,
  loading: false,
  error: null
};

const getters = {
  plans: s => s.plans,
  planById: s => id => s.plans.find(p => p.id === id),
  hasPlans: s => s.plans.length > 0,
};

const actions = {
  async fetchPlans({ state, commit }, { force = false } = {}) {
    const now = Date.now();
    if (!force && state.plans.length && (now - state.lastFetched) < CACHE_TTL_MS) return;
    try {
      commit('setLoading', true);
      const { data } = await axios.get('/subscriptions/plans');
      commit('setPlans', data);
      commit('setLastFetched', now);
    } catch (e) {
      commit('setError', e);
    } finally {
      commit('setLoading', false);
    }
  }
};

const mutations = {
  setPlans(state, plans) { state.plans = plans; },
  setLastFetched(state, ts) { state.lastFetched = ts; },
  setLoading(state, v) { state.loading = v; },
  setError(state, e) { state.error = e; }
};

export default { state, getters, actions, mutations };
